package horcrux.common.api.dtos

import arrow.core.Either
import arrow.core.raise.either
import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.api.dtos.types.UserID
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable

@Serializable
data object PostChatPagesRequest : HorcruxValidatedRequest

@Serializable
data class PostChatPagesResponse(val chatPageMetadataList: List<ChatPageMetadata>) : HorcruxResponse

open class PostChatPagesError(httpStatusCode: HttpStatusCode) : HorcruxRequestSimpleError(httpStatusCode)

data class ErrorGettingChatPagesFromDatabase(val userID: UserID, override val cause: Throwable?) :
    PostChatPagesError(HttpStatusCode.BadGateway)
